"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanetMessageType = void 0;
/**
 * This set of types essentially defines a protocol by which we can add individual `Message`s (which
 * have a `type` and a `sender` and a `timeCreated` and a `body`, where the body can really be
 * anything) to individual planets. A planet can have an unlimited amount of messages of any type.
 * Rate limiting, serializing/deserializing, enforcing ownership requirements, all these things are
 * *not* the responsibility of this message protocol. Use this as a storage mechanism and take care
 * of the buisness logic yourself.
 *
 * Currently there is one type of message that a planet can have: an single emoji 'flag' set by the
 * owner of the planet, which hovers above the planet on everyone's web client.
 *
 * In the future, we might consider building things like:
 * - a comment on a planet. anyone can just post any text comment.
 * - an emoji react to a planet.
 * - an http url set by the owner of the planet
 * - some cosmetic item that we want to give some planets.
 * - a markdown file posted by the owner of the planet.
 *
 * In the future, we might also consider supporting at the very least submitting hashes of these
 * messages on-chain.
 */
/**
 * Each message type has a corresponding entry here.
 */
var PlanetMessageType;
(function (PlanetMessageType) {
    PlanetMessageType["EmojiFlag"] = "EmojiFlag";
})(PlanetMessageType = exports.PlanetMessageType || (exports.PlanetMessageType = {}));
